import { Link, useLocation, withRouter } from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import React, { useEffect } from "react";
import Radio from "@mui/material/Radio";
import TextField from "@mui/material/TextField";
import API from "../utils/API";
import { useHistory } from "react-router-dom";
import NativeSelect from "@mui/material/NativeSelect";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

const useStyles = makeStyles((theme) => ({
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 60,

  },
  select: {
    minHeight: 30,
    background: "#fafafa",
    border: "1px",
    borderBottom: "1px",
    outline: "1px",
    color: "#555555",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "16px",
    fontWeight: "400",
    height: "19px",
    lineHeight: "19.0016px",
    margin: "0px",
    padding: "6px 0px 7px",
    width: "366px",
  },
}));

const InboundComplaint = (props) => {
  const classes = useStyles();
  // const [age, setAge] = React.useState("");
  const history = useHistory();

  const location = useLocation();

  console.log("😂",location);
  

 

  
  const [token, setToken] = React.useState("");
  const [customerNumber, setcustomerNumber] = React.useState(location.state ? location.state.phonenumber : "");
  const [remarks, setRemarks] = React.useState("");

  {/*const [query, setQuery] = React.useState("3680");

  const handleChange = (event) => {
    var value = event.target.value;

    setQuery(value);

    console.log(value);

    console.log("query is ", query);
  };*/}


  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };
  

  const [open, setOpen] = React.useState(false);
  // const handleClickOpen = () => {

  // };



  const handleClose = () => {
    setOpen(false);
  };


  ////// customerNumber /////////

  const createdBy= localStorage.getItem("userId");

  const inboundData = {
    tokenNumber:token,
    customerNumber: customerNumber,
    remarks: remarks,
    createdBy:createdBy,
  };

 



  // const update = (initialFormData) => {
  //   return {
  //     ...initialFormData,
  //     leadCategoryId: leadcategory,
  //     discountValue: discount,
  //     callbackDate: callbackdate,
  //     remarks: remarks,
  //     customerNumberId: customerNumberId,
  //     tokenId: token,
  //     createdBy: createdBy,
  //   };
  // };

  function sendLeadData(data) {
    const storedToken = localStorage.getItem("tokenStore");

    API({
      method: "POST",
      url: `/complaint`,
      headers: {
        Authorization: `Bearer ${storedToken}`,
        ContentType: "application/json",
      },
      data: inboundData,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response);
          setOpen(true);
          return response;
        } else {
          console.log("Somthing happened wrong");
        }
      })
      .catch((err) => err);
  }

  const handleSubmit = (event) => {
   
    event.preventDefault();
    console.log("Up", inboundData);
    
    if(customerNumber === "") {
      alert("Please Enter Customer Number");

    }
    else if (remarks === "") {
      alert("Please Enter Remarks ");
    }
    else
    {
    sendLeadData(inboundData);
    }
  };

  return (
    <div className="not-container" style={{ marginTop: "2%" }}>

     <FormControl className={classes.formControl} style={{ marginTop: -10 }}>
      

      
        <br />
        <TextField
          id="standard-textarea"
          className={classes.formControl}
          label="Token Number"
          type="number"
          value={token}
          name="token"
          onChange={(e) => setToken(e.target.value)}
          style={{ marginLeft: -0.5 }}
        />
        <br />
        <br />
        <TextField
          id="standard-textarea"
          label="Customer No."
          placeholder="Customer No."
          type="number"
          className={classes.formControl}
          name="customerNumber"
          value={customerNumber}
          onChange={(e) => setcustomerNumber(e.target.value)}
          style={{ marginLeft: -0.5 }}
        />

      <br />
        <TextField
          id="standard-textarea"
          label="Remarks"
          placeholder="Write Remarks"
          multiline
          rows={2}
          minWidth="240"
          className={classes.formControl}
          name="remarks"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          style={{ marginLeft: -0.5 }}
        />

        <br />
        <br />
      
        <Button
          variant="contained"
          color="primary"
         onClick={(e)=>handleSubmit(e)}
          style={{ width: "50%", marginLeft: "25%" }}
        >
          <Link exact style={{ textDecoration: "none", color: "white" }}>
            Submit
          </Link>
        </Button>
      </FormControl>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Complaint added successfully"}
        </DialogTitle>

        <DialogActions>
          {/* <Button onClick={handleClose} color="primary">
            Close
          </Button> */}
          <Button color="primary" autoFocus>
            <Link
              exact
              to="/"
              style={{ textDecoration: "none", color: "#008CBA" }}
            >
              Okay
            </Link>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withRouter(InboundComplaint);


























